import { render, staticRenderFns } from "./memberDetails.vue?vue&type=template&id=3ea2f699&lang=pug"
import script from "./memberDetails.vue?vue&type=script&lang=js"
export * from "./memberDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports